<template>
    <div class="navbar-item">
        <span :class="{'has-text-success': achieved, 'has-text-danger': !achieved}"
              class="tooltip is-tooltip-bottom" data-tooltip="Goal/Achieved">
            Your goal: {{ getCurrentUserManagerGoal | formatNumber }} / {{ getCurrentUserManagerGoalAchieved | formatNumber }}
        </span>
        <span style="padding-left: 3px;"
              :class="{'has-text-success': achieved, 'has-text-danger': !achieved}"
              class="tooltip is-tooltip-bottom"
              @click="refresh"
              data-tooltip="Refresh">
            <i v-if="achieved" class="fas fa-smile"></i>
            <i v-else class="fas fa-sad-tear"></i>
        </span>
    </div>
</template>

<script>
    export default {
        data() {
           return {
               modalStatus: false
           }
        },
        methods: {
            refresh() {
                this.$store.dispatch('fetchCurrentUserManagerGoalAchieved');
            }
        },
        computed: {
            getCurrentUserManagerGoal() {
                return this.$store.getters.getUserManagerGoal
            },
            getCurrentUserManagerGoalAchieved() {
                return this.$store.getters.getUserManagerGoalAchieved
            },
            achieved() {
                return this.getCurrentUserManagerGoalAchieved >= this.getCurrentUserManagerGoal
            }
        }
    }
</script>

<style scoped>
    span {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Navigation/Goal.vue